module.exports = __webpack_public_path__ + "img/pp-31.02b25682.jpg";